import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/serviceSalesSaga";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const SecondaryCategory = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.serviceSales.filters.secondary_categories);
  const selectedOptions = useSelector(
    (state) => state.serviceSales.selectedFilters.secondary_categories
  );

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedOptions}
      placeholder="Secondary Categories"
      numberDisplayed={0}
      includeSelectAll
      enableOnly
      height={324}
      onSelectChange={(data) => dispatch(actionCreators.updateSecondaryCategory(data))}
    />
  );
};

export default SecondaryCategory;
